import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useLocale } from '../../i18n/locale-context.js';
import { cn } from '../../lib/cn.js';
import { EmblemMark } from '../emblem/EmblemMark.js';
export function GovernmentIdentity({ ministryName, size = 'md', className, variant = 'full', }) {
    const { locale, t } = useLocale();
    const ministryLabel = ministryName ? (locale === 'ne' ? ministryName.nameNe : ministryName.nameEn) : undefined;
    if (variant === 'mark-only') {
        // The emblem's own `alt` (via `EmblemMark`) already states "नेपाल सरकार" / "Government
        // of Nepal" — wrapping it in a `role="img"` group with the same accessible name would be
        // a redundant announcement, so the bare `<img>` alt is left to do the one job on its own.
        return _jsx(EmblemMark, { height: size === 'sm' ? 32 : 40, className: className });
    }
    return (_jsxs("div", { className: cn('flex items-center gap-2', className), children: [_jsx(EmblemMark, { height: size === 'sm' ? 36 : 48 }), _jsxs("div", { className: "leading-tight", children: [_jsx("div", { className: cn('font-semibold text-gov-mark', size === 'sm' ? 'text-sm' : 'text-lg'), children: t('govIdentity.label') }), ministryLabel ? _jsx("div", { className: "text-xs text-text-muted", children: ministryLabel }) : null] })] }));
}
//# sourceMappingURL=GovernmentIdentity.js.map